let maxId = 0

/**
 * 項目のリストを渡して maxId を初期化する
 */
function init (items) {
	maxId = items.reduce((max, item) => max < item.id ? item.id : max, maxId)
}

function create () {
	return {
		id: ++maxId,
		date: null,
		date_to: null,
		time_from: null,
		time_to: null
	}
}

export default {
	init,
	create
}
